import easyXDM from "easyxdm";
import React, { useEffect, useRef } from "react";
import { createIframeAuthHost, getDefaultCredential, getDefaultSessionData } from "@/auth/iframeAuthHost";

export interface Message {
    event: string;
    data: any;
}

interface AppIFrameProps {
    url: string;
    height: string | number;
    onMessage?: (message: Message) => void;
}

export const AppIFrame = ({ url, height, onMessage }: AppIFrameProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const origin = (() => {
            try {
                return new URL(url).origin;
            } catch {
                return "";
            }
        })();

        const getIframeWindow = () => containerRef.current?.querySelector("iframe")?.contentWindow ?? null;

        const authHost = origin
            ? createIframeAuthHost({
                  getIframeWindow,
                  origin,
                  getCredential: getDefaultCredential,
                  getSessionData: () => getDefaultSessionData(origin),
              })
            : null;

        const socket = new easyXDM.Socket({
            remote: url,
            container: containerRef.current,
            props: { className: "w-full h-full" },
            onMessage(payload: string) {
                const message: Message = JSON.parse(payload);
                message.data = message.data ?? {};
                onMessage?.(message);
            },
        });

        return () => {
            authHost?.destroy();
            if (socket) {
                return socket.destroy();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);

    return <div ref={containerRef} className="iframe-content pt-2 pl-2 pb-20" style={{ height, maxHeight: height }} />;
};
